export default class ContractWithdrawalTerminateRequest {
    constructor(public contractNumber: string) {
    }
}
